import axios from 'axios'

const baseURL = 'https://psgc.gitlab.io/api/'

export default {
  getRegions() {
    return axios.get(baseURL + 'regions')
  },
  getCities(regionCode=null) {
    return axios.get(baseURL + `regions/${regionCode}/cities`)
  },
  getBarangays(cityCode=null) {
    return axios.get(baseURL + `cities/${cityCode}/barangays`)
  },
  getCity(code=null) {
    return axios.get(baseURL + `cities/${code}`)
  },
  getRegion(code=null) {
    return axios.get(baseURL + `regions/${code}`)
  },
};
